module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-box__row-wrap"
  }, [_c('div', {
    staticClass: "basic-box__row hr"
  }, [_c('div', {
    staticClass: "basic-box__row-inner"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.today),
      expression: "today"
    }],
    staticClass: "basic-box__row-item basic-box__row-item_time"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("time")(_vm.visit.begin)) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.today),
      expression: "!today"
    }],
    staticClass: "basic-box__row-item basic-box__row-item_time"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("data")(_vm.visit.begin, 'DD.MM')) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "basic-box__row-item basic-box__row-item_avatar-wrap"
  }, [_c('user-avatar', {
    attrs: {
      "data": _vm.connectUser,
      "setClass": 'basic-box__avatar'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "basic-box__row-item basic-box__row-item_name"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.connectUser.last_name) + " " + _vm._s(_vm.connectUser.first_name) + " " + _vm._s(_vm.connectUser.middle_name) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "basic-box__row-item basic-box__btns"
  }, [_c('span', {
    staticClass: "basic-box__status bold",
    class: _vm.calcStatusClass(_vm.visit.status)
  }, [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(_vm._f("status")(_vm.visit.status)) + "\n\t\t\t\t\t\t ")]), _vm._v(" "), (_vm.calcCanDoAct(_vm.visit)) ? _c('button', {
    staticClass: "basic-box__btn basic-box__btn_actions bold",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.doAct(true)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tДействия\n\t\t\t\t\t"), _c('i', {
    staticClass: "basic-box__icon basic-box__icon_dark basic-box__icon_arrow_down icon ion-chevron-down"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDoAct),
      expression: "isDoAct"
    }],
    staticClass: "outer_drop-menu",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.doAct(false)
      }
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDoAct),
      expression: "isDoAct"
    }],
    staticClass: "drop-menu"
  }, [(_vm.isDoctor && (_vm.visit.status == 'confirmed' || _vm.visit.status === 'not_confirmed')) ? _c('li', {
    staticClass: "drop-menu__item"
  }, [_c('div', {
    staticClass: "drop-menu__link drop-menu__link_orange",
    on: {
      "click": function($event) {
        _vm.startVisit(_vm.visit)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tНачать прием\n\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.isDoctor && _vm.visit.status == 'came') ? _c('li', {
    staticClass: "drop-menu__item"
  }, [_c('div', {
    staticClass: "drop-menu__link drop-menu__link_orange",
    on: {
      "click": function($event) {
        _vm.continueVisit(_vm.visit)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tПродолжить\n\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.isDoctor) ? _c('li', {
    staticClass: "drop-menu__item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.editEvent(_vm.visit)
      }
    }
  }, [_c('a', {
    staticClass: "drop-menu__link drop-menu__link_blue"
  }, [_vm._v("Редактировать")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "drop-menu__item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelVisit(_vm.visit)
      }
    }
  }, [_c('div', {
    staticClass: "drop-menu__link drop-menu__link_gray"
  }, [_vm._v("Отменить")])])])]) : _c('button', {
    staticClass: "basic-box__btn-nonact"
  }, [_vm._v("\n\t\t\t\t\tНет действий\n\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "basic-box__btn basic-box__btn_details js-details bold",
    on: {
      "click": function($event) {
        _vm.isDetails = !_vm.isDetails
      }
    }
  }, [_vm._v("\n\t\t\t\t\tДетали\n\t\t\t\t\t"), _c('i', {
    staticClass: "basic-box__icon basic-box__icon_light basic-box__icon_arrow_down icon ion-chevron-down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-box__descr",
    attrs: {
      "id": "js-details-content"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visit.description),
      expression: "visit.description"
    }],
    staticClass: "basic-box__text"
  }, [_vm._v("\n\t\t\t\tКоментарий:"), _c('span', {
    staticClass: "basic-box__text_comment"
  }, [_vm._v(_vm._s(_vm.visit.description))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDetails),
      expression: "isDetails"
    }]
  }, [_c('p', {
    staticClass: "basic-box__text"
  }, [_vm._v("\n\t\t\t\t\tДата: "), _c('span', {
    staticClass: "basic-box__text_date"
  }, [_vm._v(_vm._s(_vm._f("data")(_vm.visit.begin, 'DD.MM.YY HH:mm')))])]), _vm._v(" "), (!_vm.isDoctor) ? _c('p', {
    staticClass: "basic-box__text"
  }, [_vm._v("\n\t\t\t\t\tМесто: " + _vm._s(_vm.connectUser.phone) + "\n\t\t\t\t\t"), _c('span', {
    staticClass: "basic-box__text_place"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.visit.clinic.name) + " (" + _vm._s(_vm.visit.clinic.city.name) + ", " + _vm._s(_vm.visit.clinic.street) + " " + _vm._s(_vm.visit.clinic.house) + ")\n\t\t\t\t\t")])]) : _c('p', {
    staticClass: "basic-box__text"
  }, [_vm._v("\n\t\t\t\t\tТелефон:"), _c('span', {
    staticClass: "basic-box__text_phone"
  }, [_vm._v("\n\t\t\t\t\t+" + _vm._s(_vm.connectUser.phone) + "\n\t\t\t\t")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a055b1a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VisitItem.vue
// module id = 640
// module chunks = 0